"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuItem = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _Menu = require("../Menu/Menu.context");
var _MenuItem = require("./MenuItem.styles");
var _excluded = ["children", "icon", "onClick"];
/**
 * Menu items are HTML buttons by default that close the `Menu` and take an action when
 * clicked.
 *
 * @since 7.28.0
 */
var MenuItem = function MenuItem(props) {
  var _useContext = (0, _react.useContext)(_Menu.MenuContext),
    onActivate = _useContext.onActivate;
  var children = props.children,
    icon = props.icon,
    onClick = props.onClick,
    rest = (0, _objectWithoutProperties2.default)(props, _excluded);
  var onClickCallback = (0, _react.useCallback)(function (e) {
    // Let `Menu` know the item was activated
    if (onActivate) {
      onActivate();
    }

    // Take the action
    if (onClick) {
      onClick(e);
    }
  }, [onActivate, onClick]);
  return /*#__PURE__*/_react.default.createElement(_MenuItem.StyledMenuItem, (0, _extends2.default)({}, rest, {
    onClick: onClickCallback
  }), icon, children);
};
exports.MenuItem = MenuItem;
MenuItem.displayName = 'MenuItem';
MenuItem.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Item text content.
   */
  'children': _propTypes.default.node.isRequired,
  /**
   * An optional `Icon` node.
   */
  'icon': _propTypes.default.node,
  /**
   * The action to perform when the menu item is activated with a click or with keyboard
   * interaction.
   */
  'onClick': _propTypes.default.func,
  /**
   * Menu items have the role of `"menuitem"` by default per the
   * [accesibility guidelines](https://www.w3.org/WAI/ARIA/apg/example-index).
   */
  'role': _propTypes.default.string,
  /**
   * Set the menu item as disabled when using a button.
   */
  'disabled': _propTypes.default.bool,
  /**
   * Use aria-disabled in the event that the menu item is an `Anchor`.
   */
  'aria-disabled': _propTypes.default.bool
} : {};
MenuItem.defaultProps = {
  'icon': undefined,
  'onClick': undefined,
  'role': 'menuitem',
  'disabled': undefined,
  'aria-disabled': undefined
};